import { loadState } from "@nextcloud/initial-state";
function getCapabilities() {
  try {
    return loadState("core", "capabilities");
  } catch (error) {
    console.debug("Could not find capabilities initial state fall back to _oc_capabilities");
    if (!("_oc_capabilities" in window)) {
      return {};
    }
    return window["_oc_capabilities"];
  }
}
export {
  getCapabilities
};
//# sourceMappingURL=index.mjs.map
